
import React, { useState, useEffect, useRef } from "react";
import "./style/style.css";
import { assets } from "../../../assets/assets";
import ar from "../../../lang/ar";
import en from "../../../lang/en";
function NotesMap({ isNotesOpen, onToggleNotes, lang }) {
  const translations = lang === "ar" ? ar : en;
  const collapseRef = useRef(null);
  const [height, setHeight] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (isNotesOpen && collapseRef.current) {
      setHeight(collapseRef.current.scrollHeight);
    } else {
      setHeight(0);
    }
  }, [isNotesOpen]);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <div className={`note-container`} dir={lang === "ar" ? "rtl" : "ltr"}>

      <div className="note-wrapper">
        <button
          className="btn icon-container"
          type="button"
          onClick={onToggleNotes}
          aria-expanded={isNotesOpen}
        >
          <img src={assets.note} alt="Note Icon" />
        </button>

        <div
          ref={collapseRef}
          className={`note-collapse ${isNotesOpen ? "open" : ""}`}
          style={{
            height: `${height}px`,
            overflow: "hidden",
            transition: "height 0.5s ease-in-out, opacity 0.5s ease-in-out",
            opacity: isNotesOpen ? 1 : 0,
          }}
        >
          <div className="card card-body note-card">
            <p>
              { translations.captionNotes }
            </p>
            <button className="export-note p-0" onClick={openModal}>
              { translations.ViewFull }
              <img src={assets.export_note} alt="" />
            </button>
          </div>
        </div>
      </div>

      {/* ✅ المودال */}
      {isModalOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div
            className="custom-modal"
            onClick={(e) => e.stopPropagation()} // عشان الضغط جوه المودال ما يقفلش
          >
            <div className="modal-header">
              <div className="modal-title">
                <div>
                  <img src={assets.note} alt="" />
                </div>
                <p className="m-0 p-0">Notice</p>
              </div>
              <button className="close-button" onClick={closeModal}>
                <img src={assets.close_circle} alt="" />
              </button>
            </div>
            <p>
             { translations.DescriptionNotes1 }
            </p>
            <p>
              { translations.DescriptionNotes2 }
            </p>
            <p>
              { translations.DescriptionNotes3 }
            
            </p>
            <p>
              { translations.DescriptionNotes4 }
            </p>
            <p>
              { translations.DescriptionNotes5 }
            </p>
            <button className="close-modal-btn" onClick={closeModal}>
              { translations.btnNotes }
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default NotesMap;







